// src/theme.ts
import { createTheme, rem } from "@mantine/core";

/** BodyOwn brand */
const brand = [
  "#eef6f6", "#d9eceb", "#c2e1de", "#a8d6d0", "#8ccbc2",
  "#6fbfb3", "#52b3a5", "#389b8f", "#257a73", "#1E5E5B",
];

const accent = [
  "#fdebf0", "#f9d1de", "#f2b6c9", "#ea9ab2", "#e07c9a",
  "#d55e83", "#c93f6b", "#B82854", "#9f2248", "#861b3c",
];

const theme = createTheme({
  colors: {
    brand,
    accent,
    // ❌ do NOT set `gray: undefined` or any non-10-length arrays
  },
  primaryColor: "brand",
  primaryShade: 9, // brand[9] = #1E5E5B
  fontFamily:
    'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
  headings: {
    fontFamily:
      'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
    sizes: {
      h1: { fontSize: rem(28), fontWeight: "700", lineHeight: "1.2" },
      h2: { fontSize: rem(24), fontWeight: "700", lineHeight: "1.25" },
      h3: { fontSize: rem(20), fontWeight: "600", lineHeight: "1.3" },
    },
  },
  defaultRadius: "lg",
  lineHeights: { md: "1.6", lg: "1.75" },

  components: {
    Button: { defaultProps: { size: "md", radius: "xl" } },
    Progress: { defaultProps: { radius: "xl" } },
    Paper: { defaultProps: { shadow: "sm", radius: "lg", withBorder: true } },
  },
});

export default theme;
